"use client";

import { useEffect, useState } from "react";

import {
  GAM_BASE_POST_CTA_MOBILE_AD_UNIT,
  GAM_BASE_POST_CTA_MOBILE_ENABLED,
  GAM_BASE_POST_CTA_MOBILE_MIN_HEIGHT,
  GAM_BASE_POST_CTA_MOBILE_SIZES,
} from "@/components/ads/config";
import GamDisplaySlot from "@/components/ads/GamDisplaySlot";

import styles from "./BaseArticle.module.css";

type TargetingValue =
  | string
  | number
  | boolean
  | Array<string | number | boolean>;

type Props = {
  targeting?: Record<string, TargetingValue | null | undefined>;
};

const MOBILE_QUERY = "(max-width: 767px)";

export default function BasePostCtaMobileAd({ targeting }: Props) {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_QUERY);

    const update = () => {
      setIsMobile(mediaQuery.matches);
    };

    update();
    mediaQuery.addEventListener("change", update);

    return () => {
      mediaQuery.removeEventListener("change", update);
    };
  }, []);

  if (!GAM_BASE_POST_CTA_MOBILE_ENABLED || isMobile !== true) {
    return null;
  }

  return (
    <div
      className={styles.postCtaAdWrap}
      data-base-mobile-ad="post-cta"
      data-base-mobile-ad-role="post-cta-square"
    >
      <div className={styles.postCtaAdBox}>
        <div className={styles.adHeader}>
          <span className={styles.sponsored}>Sponsored</span>
        </div>

        <GamDisplaySlot
          id="base-post-cta-mobile"
          adUnit={GAM_BASE_POST_CTA_MOBILE_AD_UNIT}
          sizes={[...GAM_BASE_POST_CTA_MOBILE_SIZES]}
          minHeight={GAM_BASE_POST_CTA_MOBILE_MIN_HEIGHT}
          lazyRootMargin="700px 0px"
          targeting={{
            page_type: "base",
            device: "mobile",
            position: "after_open_in_clash_cta",
            placement: "base_post_cta_mobile",
            placement_detail: "base_post_cta_mobile_lazy_square",
            placement_group: "support_mobile",
            inventory_tier: "support_square",
            bfc_ad_mode: "post_cta_square",
            demand_formats: ["display", "rectangle"],
            ...targeting,
          }}
        />
      </div>
    </div>
  );
}
